import { ARRoot } from "@animech/ar";
import { FunctionComponent } from "react";

export const ARRootWrapper: FunctionComponent = () => (
	// data-ar-root is used to target ARModal styling explicitly
	<div data-ar-root>
		<ARRoot />
	</div>
);
